import React from 'react';

import SimpleSearchSelect from '../../Forms/Input/SimpleSearchSelect';

import QuickAddProductUnit from '../../QuickAdd/ProductUnit/QuickAddProductUnit';

import { IProductUnitCreate } from '../../../types/productUnit/productUnitInterfaces';
import { ProductFormValues } from '../../../types/product/ProductFormValues';

import { useProduct } from '../../../hooks/useProduct';

interface Props {
  form: ProductFormValues;

  unitOptions: any[];

  onChange: (
    field: keyof ProductFormValues,
    value: any
  ) => void;

  onReloadUnits: () => void;

  onUnitCreated?: (
    data: IProductUnitCreate
  ) => Promise<void> | void;
}

const ProductConfiguration: React.FC<Props> = ({
  form,
  unitOptions,
  onChange,
  onReloadUnits,
  onUnitCreated,
}) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 gap-6">

      <div>
        <h2 className="text-lg font-semibold text-black dark:text-white">
          Configuración
        </h2>

        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Define la unidad de medida utilizada para controlar el inventario.
        </p>
      </div>

      <div className="flex flex-col gap-2">

        <QuickAddProductUnit
          onUnitCreated={onUnitCreated}
          onReload={onReloadUnits}
        />

        <SimpleSearchSelect
          label="Unidad de Medida"
          name="unitId"
          iconKey="listOrdered"
          options={unitOptions}
          selectedValue={form.unitId}
          onSelect={(selectedOption) =>
            onChange(
              'unitId',
              selectedOption?.id ?? null
            )
          }
          error={formErrors.unitId}
          required
        />

      </div>

    </div>
  );
};

export default ProductConfiguration;